import React from 'react';
import Tooltip from './Tooltip';

interface Props {
	children: React.ReactChild | React.ReactChild[];
}

const InfoTooltip: React.FC<Props> = ({ children }) => {
	return (
		<Tooltip
			trigger={
				<img
					src='/dist/icons/v2/circle-info-solid.svg'
					alt='info'
					height='20px'
					width='20px'
					className='ml-2'
					style={{ marginBottom: '4px' }}
				/>
			}>
			{children}
		</Tooltip>
	);
};

export default InfoTooltip;
